<div *ngIf="userName.firstName || userName.lastName; else userInfoNoAvail">
  <fm-header
    [firstLevelMenu]="levelOneMenu"
    [userName]="userName"    
    [profileMenuItems]="items"
    [noFixed]="true"   
    currentApp="DUS Data Digitizer®"     
    [smallLogo]="false"
    [alignMenuRight]="true"
    >
  </fm-header>
</div>

<ng-template #userInfoNoAvail>
  <fm-header
    [firstLevelMenu]="levelOneMenu"
    [profileMenuItems]="items"
    [smallLogo]="false"
    currentApp="DUS Data Digitizer®"
    (iconClicked)="onIconClick()"
    [noFixed]="true"
    [homeUrl]="'#'"
    [alignMenuRight]="true"
    >
  </fm-header>
</ng-template>
